<template>
    <div>
        <div v-if="completed">
            <div class="alert alert-success">
                {{translate('login.passwordResetSuccessful')}}
                <p class="text-right">
                    <router-link to="/" class="btn btn-success">{{translate('okay')}}</router-link>
                </p>
            </div>
        </div>
        <form @submit.prevent="reset" v-else-if="isValid">
            <fieldset :disabled="loading">
                <div class="form-group" v-if="showCode">
                    <label>{{translate('login.accountCode')}}</label>
                    <input v-model="data.AccountCode" readonly type="text" class="form-control" />
                </div>
                <div class="form-group">
                    <label>{{translate('login.email')}}</label>
                    <input v-model="data.Email" readonly type="email" class="form-control" />
                </div>
                <div class="form-group">
                    <div class="d-flex justify-content-between">
                        <label>{{translate('login.newPassword')}}</label>
                        <div :title="translate('login.passwordResetTitle')" v-title> <img src="../../assets/information.png" class="informationIcon" alt=""> </div>
                        <modifier-key-state-warning/>
                    </div>
                    <!--<input v-model="form.Password" ref="password" required type="password" class="form-control"  onpaste="return false;" oncopy="return false;" autofill="return false;" />-->
                    <input type="password" v-model="form.Password" ref="password" required class="form-control"  onpaste="return false;" oncopy="return false;" autofill="return false;"/>
                    <span v-if="score === 0">{{translate('login.chooseStrongerPassword')}}</span>
                    <password-meter :password="form.Password" @score="onScore" />
                </div>
                <div class="form-group">
                    <div class="d-flex justify-content-between">
                        <label>{{translate('login.newPasswordAgain')}}</label>
                        <div :title="translate('login.passwordResetTitle')" v-title> <img src="../../assets/information.png" class="informationIcon" alt=""> </div>
                        <modifier-key-state-warning/>
                    </div>
                    <!--<input v-model="form.Password2" required type="password" class="form-control"  onpaste="return false;" oncopy="return false;" autofill="return false;" />-->
                    <input type="password" v-model="form.Password2" ref="password" required class="form-control"  onpaste="return false;" oncopy="return false;" autofill="return false;"/>
                    <password-meter :password="form.Password2" @score="onScore" />
                </div>
                <button type="submit" class="btn btn-primary">{{translate('login.changePassword')}}</button>
                <div v-if="errorMessage" class="text-danger">{{translate('login.error')}} {{errorMessage}}</div>
            </fieldset>
        </form>
        <div v-else class="alert alert-danger">
            {{errorMessage}}
            <p class="text-right">
                <router-link to="/" class="btn btn-danger">{{translate('okay')}}</router-link>
            </p>
        </div>
    </div>
</template>

<script>
import ModifierKeyStateWarning from '@/components/ModifierKeyStateWarning.vue'
import axios from 'axios'
import passwordMeter from "vue-simple-password-meter";

export default {
  name: 'PasswordReset',
  components:{
      ModifierKeyStateWarning,
      passwordMeter
  },
  props: {
    
  },
  data: () => ({
    loading: false,
    isValid: true,
    form: {},
    errorMessage : null,
    showCode: false,
    completed: false,
    data: {
        AccountCode: window.settings.defaultAccountCode
    },
    score: null
  }),
  created(){
        this.validateRequest();
  },
  methods: {
        validateRequest(){
            this.loading = true;
            return axios.post('/passwordreset/validaterequest', {
                RequestId: this.$route.params.id,
                ValidationKey: this.$route.query.key
            })
            .then(x => {
                if(x.data.Success) {
                    this.isValid = true;
                    this.data = x.data.Data;
                } else {
                    this.isValid = false;
                    this.errorMessage = x.data.ErrorMessages;
                }
                this.loading = false;
            })
            .catch(x => {
                this.isValid = false;
                this.errorMessage = this.translate('errors.passwordLinkCannotVerified');
                console.log(x);
                this.loading = false;
            })
        },
        reset(){
            if(this.form.Password != this.form.Password2) {
                alert(this.translate('errors.passwordMismatch'));
                this.$refs.password.focus();
                return;
            }

            this.loading = true;
            axios.post('/passwordreset/changepassword', {
                RequestId: this.$route.params.id,
                ValidationKey: this.$route.query.key,
                NewPassword: this.form.Password
            })
            .then(x => {
                this.errorMessage = null;
                console.log("Gelen sonuç:", x);
                if(x.data.Success) {
                    this.completed = true;
                } else {
                    this.errorMessage = x.data.ErrorMessages;
                    this.completed = false;
                }
                this.loading = false;
            }).catch(e => {
                window.processErrorResponse(e, this);
                // console.log('Error:', e);
                // if(e.response === undefined) {
                //     this.errorMessage = "Erişim sağlanamadı. Lütfen internet bağlantınızı kontrol edin.";
                // } else {
                //     this.errorMessage = "Beklenmeyen bir hata oluştu. Lütfen bir süre sonra tekrar deneyin";
                // }
                this.loading = false;

            })

            
        },
        onScore({score}){
            this.score = score;
        }
  }
}
</script>
<style scoped>
.captcha {
    width:100px;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
}
.informationIcon{
    width: 24px;
    height: auto;
}
</style>